import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { createTag } from 'api/Tags';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import { showAlert } from 'components/shared/Alert/Alert';

export const useCreateTag = ({ kind, onSuccess } = {}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useCustomMutation({
    mutationFn: (data) => createTag(navigate, data),
    successMessage: 'Tag created',
    handleResponse: (data) =>
      showAlert({ title: data?.error || "Couldn't create tag", color: 'danger' }),
    // Nested: a flat array is treated as a LIST of keys, which would invalidate
    // ['tags'] and the kind separately instead of the composite key.
    invalidateQueryKey: [['tags', kind]],
    onSuccess: (data) => {
      // Seed the new tag so the list reflects it before the refetch lands.
      queryClient.setQueriesData(['tags', kind], (oldData) =>
        oldData?.tags ? { ...oldData, tags: [...oldData.tags, data?.tag] } : oldData
      );
      onSuccess?.(data);
    }
  });
};
